import * as React from 'react';
import ReactDOM from 'react-dom';
import ReactGA from 'react-ga';
import { ReportHandler } from 'web-vitals';
import App from 'src/components/App';

import * as Sentry from '@sentry/react';
import { BrowserRouter } from 'react-router-dom';
// Google Analytics
ReactGA.initialize(process.env.REACT_APP_GTAG_ID || '');

const reportWebVitals = (onPerfEntry?: ReportHandler) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(onPerfEntry);
      getFID(onPerfEntry);
      getFCP(onPerfEntry);
      getLCP(onPerfEntry);
      getTTFB(onPerfEntry);
    });
  }
};

export default reportWebVitals;

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  integrations: [
    new Sentry.BrowserTracing({
      // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: ['https://dashboard-staging.trustfull.com', 'https://dashboard.trustfull.com'],
    }),
    new Sentry.Replay({
      networkDetailAllowUrls: [/dashboard-backend.*fido\.id/],
      maskAllText: false,
    }),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, // Capture 100% of the transactions, reduce in production!
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

// Transform all React.StrictMode errors into warnings
const originalConsoleError = console.error;

console.error = (s: string) => {
  if (s.toString().startsWith('Warning:')) {
    console.warn(s);
  } else {
    originalConsoleError(s);
  }
};

// eslint-disable-next-line
ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);
